export default __webpack_public_path__ + "2c8c0c6e2b3077be5133a2233bf51a59.png";